import * as services from '@services/index';
import { IAndrologyIllnessInfo } from '@/schemas/andrology-center';

interface IState {
  andrologyIllnessList: IAndrologyIllnessInfo[];
  andrologyIllnessTabs: Array<{
    key: number;
    value: string;
  }>;
}

const initState: IState = {
  andrologyIllnessList: [],
  andrologyIllnessTabs: []
};

const andrologyCenter = {
  state: initState,

  reducers: {
    updateState(state: IState, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (dispatch) => ({
    async getAndrologyIllnessList() {
      try {
        const res = await services.andrologyCenter.getAndrologyIllnessList();

        this.updateState({
          andrologyIllnessTabs: res.tabs,
          andrologyIllnessList: res.result
        });
      } catch (err) {
        //
      }
    }
  })
};

export default andrologyCenter;
